import GroupTemplateBadge from './GroupTemplateBadge';

/**
 * GroupHeader — шапка экрана группы пресетов.
 *
 * Figma source: `318:4660` header block (402×402 full-width).
 * Children (все absolute):
 *   - image 8  (cover)           — 402×402 image fill + GRADIENT_LINEAR 180°
 *       scrim (bg-app α 0 → 0.24 @ 55% → 1 @ 100%) — fills[1] в Figma,
 *       обеспечивает читаемость logo/badge на bright cover-изображениях.
 *   - image 9 1 (logo)           — 160px wide, centered horizontal, y=278
 *   - uiButton secondary sm      — 115×32, centered horizontal, y=354
 *   - StatusBar                  — abs top (рендерит PresetGroupDetail page, не header)
 *
 * Координаты top=288 / top=354 — pixel-perfect из Figma (acceptance §2.3.3
 * допускает inline-style для Figma-координат; hex-литералы запрещены).
 *
 * Props:
 *   - coverUrl       — string, required (always shown as image/poster)
 *   - videoUrl       — string | null — opt. MP4 auto-played muted loop on
 *                      top of the image; cover acts as the poster so the
 *                      page renders instantly while the video downloads.
 *   - logoUrl        — string | null — если null, overlay не рендерится
 *   - logoLayout     — 'wide' | undefined — для длинных низких movie-title
 *                      логотипов, которые иначе выглядят слишком мелко
 *   - templateCount  — integer — число пресетов в группе
 */
export default function GroupHeader({ coverUrl, videoUrl, logoUrl, logoLayout, templateCount }) {
  const isWideLogo = logoLayout === 'wide';

  return (
    <div className="relative w-full aspect-square overflow-hidden">
      <img
        src={coverUrl}
        alt=""
        className="absolute inset-0 w-full h-full object-cover"
        loading="eager"
        fetchpriority="high"
        decoding="async"
      />
      {videoUrl && (
        <video
          src={videoUrl}
          poster={coverUrl}
          autoPlay
          muted
          loop
          playsInline
          preload="metadata"
          className="absolute inset-0 w-full h-full object-cover"
          data-testid="group-header-video"
        />
      )}
      {/* bottom-scrim gradient — Figma 318:4661 fills[1] GRADIENT_LINEAR 180°
          stops: bg-app α=0 @ 0% → α=0.24 @ 55% → α=1 @ 100%. Positioned
          between image и logo/badge overlays (z-order: img → video → scrim
          → logo → badge) so logo/badge always read on top of the darkened
          bottom. */}
      <div
        aria-hidden
        data-testid="group-header-scrim"
        className="absolute inset-0 pointer-events-none bg-cover-scrim"
      />
      {logoUrl && (
        <img
          src={logoUrl}
          alt="logo"
          className="absolute left-1/2 -translate-x-1/2 object-contain"
          style={{
            top: isWideLogo ? '282px' : '278px',
            width: isWideLogo ? '80%' : '40%',
            maxWidth: isWideLogo ? '320px' : '160px',
            height: 'auto',
            maxHeight: '80px',
          }}
        />
      )}
      <div
        className="absolute left-1/2 -translate-x-1/2"
        style={{ top: '354px' }}
      >
        <GroupTemplateBadge count={templateCount} />
      </div>
    </div>
  );
}
